import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyHippoMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#9fb6c8" />
      <ellipse cx={400} cy={760} rx={260} ry={120} fill="#6b7b83" />
      <g className="mode-copy" transform="translate(48,840)" fill="#122">
        <text x={0} y={0} fontSize={18}>{Copy?.title}</text>
      </g>
    </g>
  );
}

export default VasarelyHippoMode;
